/**
 * @module Services/Bff/Presenters/Campaign
 * @desc Campaign Presenter
 *
 */

import type { Campaign } from 'core/domains';

import { CampaignResponse } from '../../@types';

/**
 * Transforms the campaign response data model into the campaign domain model
 *
 */

export function campaignPresenter({ data }: CampaignResponse): Campaign['data'] {
  const { items, minimumItemPoints, orderUsedPoints, remainingPoints } = data;

  const amountPoints = Number(remainingPoints) + Number(orderUsedPoints);
  const hasRequiredPoints = minimumItemPoints < amountPoints;

  return {
    ...data,
    items: items.map((item) => ({
      ...item,
      quantity: 0,
      previousQuantity: 0,
      disabled: Number(remainingPoints) < item.requiredPoints,
    })),
    hasRequiredPoints,
  };
}
